<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <video id="videoplayer-placeholder" style="display: none"></video>

    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon> Back
    </div>
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />
    <div class="header text-left">Edit Videos</div>
    <v-row class="cover-photo">
      <v-col cols="12">
        <label for="video">Video</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          id="video"
          type="file"
          accept="video/mp4"
          @change="(e) => setVideo(e.target.files[0])"
        />
        <input type="text" readonly v-model="videoFileName" />
      </v-col>
      <v-col cols="6" md="3">
        <label for="video" id="browse-btn">Browse</label>
      </v-col>
    </v-row>
    <v-row class="cover-photo">
      <v-col cols="12">
        <label for="cover-photo">Image</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          id="cover-photo"
          type="file"
          accept="image/x-png, image/jpeg"
          @change="(e) => setImage(e.target.files[0])"
        />
        <input type="text" readonly v-model="imageFileName" />
      </v-col>
      <v-col cols="6" md="3">
        <label for="cover-photo" id="browse-btn">Browse</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <label for="title">Title</label>
        <input id="title" type="text" v-model="title" />
        <div class="error-msg" v-show="$v.title.$invalid">
          This is a required field.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <label for="sequence">Sequence</label>
        <input id="sequence" type="text" v-model="sequence" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="submitVideoForm"
          >Submit</v-btn
        >
      </v-col>
      <v-col cols="6" md="3">
        <v-btn color="#EA6254" @click="deleteVideoItem">Delete</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">Video updated successfully.</v-alert>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import Dialog from "./commons/Dialog";
import { required } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";
import moment from "moment";

export default {
  components: {
    Dialog,
    LoadingScreen,
  },

  data() {
    return {
      title: "",
      imageFile: null,
      videoFile: null,
      selectedId: this.$route.params.itemId,
      imageUrl: null,
      videoUrl: null,
      dialog: false,
      imageFileName: null,
      videoFileName: null,
      videoDuration: null,
      videoChanged: false,
      loading: false,
      success: false,
      error: false,
      sequence: null,
    };
  },

  validations: {
    title: {
      required,
    },

    imageFileName: {
      required,
    },

    videoFileName: {
      required,
    },
  },

  mounted() {
    axios
      .get(
        process.env.VUE_APP_HOST_SERVER + "/api/videos/get/" + this.selectedId
      )
      .then((res) => this.processFetchedData(res.data))
      .catch((err) => console.log(err));
  },

  methods: {
    processFetchedData(data) {
      this.title = data.title;
      this.videoFileName = data.videoUrl.slice(77);
      this.imageFileName = data.imageUrl.slice(77);
      this.imageUrl = data.imageUrl;
      this.videoUrl = data.videoUrl;
      this.videoDuration = data.duration;
      this.sequence = data.sequence;
    },

    setImage(file) {
      if (file !== null) {
        // Set image file
        this.imageFile = file;
        this.imageFileName = file.name;
      }
    },

    setVideo(file) {
      if (file !== null) {
        // Set video file and file name
        this.videoFile = file;
        this.videoFileName = file.name;

        // Set video in video player placeholder to get duration of video
        let video = document.getElementById("videoplayer-placeholder");
        video.preload = "metadata";

        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
        };
        video.src = URL.createObjectURL(file);

        this.videoChanged = true;
      }
    },

    submitVideoForm() {
      this.loading = true; //enable loading screen when user clicks submit

      let videoDuration;
      if (this.videoChanged == false) {
        videoDuration = this.videoDuration;
      } else {
        videoDuration = moment
          .utc(
            document.getElementById("videoplayer-placeholder").duration * 1000
          )
          .format("mm:ss");
      }

      const videoImageFormData = new FormData();
      videoImageFormData.append("imageFile", this.imageFile);

      const videoFormData = new FormData();
      videoFormData.append("videoFile", this.videoFile);

      if (this.imageFile && this.videoFile) {
        axios
          .post(
            process.env.VUE_APP_HOST_SERVER + "/api/image_upload/videos",
            videoImageFormData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((res) => {
            console.log(
              "Successfully uploaded video image ",
              res.data.imageUrl
            );
            this.imageUrl = res.data.imageUrl;

            axios
              .post(
                process.env.VUE_APP_HOST_SERVER + "/api/video_upload",
                videoFormData,
                {
                  headers: { "Content-Type": "multipart/form-data" },
                }
              )
              .then((res) => {
                console.log("Successfully uploaded video", res.data.videoUrl);

                this.videoUrl = res.data.videoUrl;

                const videoDetails = {
                  title: this.title,
                  imageUrl: this.imageUrl,
                  videoUrl: this.videoUrl,
                  duration: videoDuration,
                  sequence: this.sequence,
                };

                axios
                  .post(
                    process.env.VUE_APP_HOST_SERVER + "/api/videos/add",
                    videoDetails
                  )
                  .then(() => {
                    this.loading = false; //disables loading once add video request is handled by server
                    this.success = true; //shows success messaage
                    this.error = false;
                  });
              });
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      } else if (this.imageFile && !this.videoFile) {
        axios
          .post(
            process.env.VUE_APP_HOST_SERVER + "/api/image_upload/videos",
            videoImageFormData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((res) => {
            console.log(
              "Successfully uploaded video image ",
              res.data.imageUrl
            );

            this.imageUrl = res.data.imageUrl;

            const videoDetails = {
              title: this.title,
              imageUrl: this.imageUrl,
              videoUrl: this.videoUrl,
              duration: videoDuration,
              sequence: this.sequence,
            };

            axios
              .post(
                process.env.VUE_APP_HOST_SERVER +
                  "/api/videos/edit/" +
                  this.selectedId,
                videoDetails
              )
              .then(() => {
                this.loading = false; //disables loading once add video request is handled by server
                this.success = true; //shows success messaage
                this.error = false;
              });
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      } else if (this.videoFile && !this.imageFile) {
        axios
          .post(
            process.env.VUE_APP_HOST_SERVER + "/api/video_upload",
            videoFormData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((res) => {
            console.log("Successfully uploaded video", res.data.videoUrl);

            this.videoUrl = res.data.videoUrl;

            const videoDetails = {
              title: this.title,
              imageUrl: this.imageUrl,
              videoUrl: this.videoUrl,
              duration: videoDuration,
              sequence: this.sequence,
            };

            axios
              .post(
                process.env.VUE_APP_HOST_SERVER +
                  "/api/videos/edit/" +
                  this.selectedId,
                videoDetails
              )
              .then(() => {
                this.loading = false; //disables loading once add video request is handled by server
                this.success = true; //shows success messaage
                this.error = false;
              });
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      } else {
        const videoDetails = {
          title: this.title,
          imageUrl: this.imageUrl,
          videoUrl: this.videoUrl,
          duration: videoDuration,
          sequence: this.sequence,
        };

        axios
          .post(
            process.env.VUE_APP_HOST_SERVER +
              "/api/videos/edit/" +
              this.selectedId,
            videoDetails
          )
          .then(() => {
            this.loading = false; //disables loading once add video request is handled by server
            this.success = true; //shows success messaage
            this.error = false;
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      }
    },

    goBack() {
      this.$router.push({ name: "Videos" }).catch(() => {});
    },

    deleteVideoItem() {
      this.dialog = true;
    },

    confirmDeleteItem() {
      this.loading = true; //enable loading screen when user clicks delete

      this.dialog = false;

      axios
        .delete(
          process.env.VUE_APP_HOST_SERVER +
            "/api/videos/delete/" +
            this.selectedId
        )
        .then(() => {
          console.log("Deleted video from database.");
          axios
            .delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
              data: {
                s3Url: this.videoUrl,
              },
            })
            .then(() => {
              console.log("Deleted video from s3");
              axios
                .delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
                  data: {
                    s3Url: this.imageUrl,
                  },
                })
                .then(() => {
                  console.log("Deleted image from s3");
                  this.loading = false; //disable loading screen once request is handled;
                  this.goBack(); //go back to overview page once video is deleted
                });
            })
            .catch((err) => console.log(err));
        });
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.cover-photo div:first-child {
  padding-bottom: 0;
}

.cover-photo div:nth-child(2),
.cover-photo div:nth-child(3) {
  padding-top: 0;
}

#cover-photo,
#video {
  display: none;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"] {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}
</style>
